<template>
  <div>
    <commonTable
      ref="commonTable"
      url="admin/money_logs/list"
      reqMethod="GET"
      :column="column"
      :searchColumn="searchColumn"
      limitKey="per_page"
    >
    </commonTable>
  </div>
</template>

<script>
import fetch from "@/assets/js/axios.js"
import commonTable from '@/component/commonTable.vue'
export default {
  name: 'coinManager',
  components: {
    commonTable
  },
  data () {
    return {
      searchColumn: [
        {
          label: "用户名",
          prop: "username",
          type: "input",
        },
      ],
    }
  },
  computed: {
    column () {
      return [
        {
          label: "用户id",
          prop: "user.id",
          fixed: true
        },
        {
          label: "用户名",
          prop: "user.username",
          fixed: true
        },
        {
          label: "变动前余额",
          prop: "before",
          formatter: (row, column, cellValue) => {
            return '￥' + cellValue
          }
        },
        {
          label: "金额变动",
          prop: "amount",
          formatter: (row, column, cellValue) => {
            return '￥' + cellValue
          }
        },
        {
          label: "变动后余额",
          prop: "after",
          formatter: (row, column, cellValue) => {
            return '￥' + cellValue
          }
        },
        {
          label: "变动原因",
          prop: "remark.desc"
        },
        {
          label: "创建时间",
          prop: "created_at",
        },
        {
          label: "更新时间",
          prop: "updated_at",
        },
      ]
    },
  },
  mounted () {
  },
  methods: {
  }
}
</script>

<style lang="less" scoped>
.order-statistics {
  width: 100%;
  height: 60px;
  display: flex;
  align-items: center;
  padding-left: 0;
  color: rgba(0, 0, 0, 0.7);
  margin-bottom: 30px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  padding-left: 10px;
  list-style: none;
  li {
    margin-right: 30px;
  }
}

</style>
